"use strict";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Create an object with the array values as keys, and the values all set to 1
module.exports = function makeSet(source) {
  return source.reduce(function (acc, val) {
    return Object.assign(acc, _defineProperty({}, val, 1));
  }, {});
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/f1-js-utils/makeSet.js
// module id = 1144
// module chunks = 0